
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[id]/long-free/[slug]",
      function () {
        return require("private-next-pages/[id]/long-free/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[id]/long-free/[slug]"])
      });
    }
  